const ns = require('nouislider')
const wn = require('wnumb')

export default class Filter {
    constructor() {
        this.sidebar = $('.list__filters')
        this.sidebarToggler = $('.list__filters__toggler')
        this.filterApply = $('.list__filters__apply')
        this.listGridLayer = $('.list__grid__layer')
        this.inputCheckbox = $('.list__filters input[type=checkbox]')
        this.filterButtonContainer = $('#filter-button-container')
        this.filterButton = $('button.filter-button')
        this.productContainer = $('.product.list__grid__item')
        this.slider = null
        this.range = document.querySelector('.range-filter__slider')
        this.rangeMin = document.querySelector('input[name=filter_min]')
        this.rangeMax = document.querySelector('input[name=filter_max]')
    }

    /**
     * Set slider instance
     */
    startRange() {
        this.slider = ns.create(this.range, {
            start: [this.range.dataset.currentMin, this.range.dataset.currentMax],
            connect: true,
            range: {
                'min': parseInt(this.range.dataset.min),
                'max': parseInt(this.range.dataset.max)
            }
        })

        this.slider.on('update', e => this.updateValues(e))

        this.rangeMin.addEventListener('keyup', e => this.updateSlider(e))
        this.rangeMax.addEventListener('keyup', e => this.updateSlider(e))
    }

    /**
     * Update range values
     */
    updateValues(e) {
        this.rangeMin.value = parseInt(this.slider.get()[0])
        this.rangeMax.value = parseInt(this.slider.get()[1])
    }

    /**
     * Update slider values
     */
    updateSlider(e) {
        this.slider.set([this.rangeMin.value, this.rangeMax.value])
    }

    /**
     * Toggle filters on mobile
     */
    toggleSidebar(scroll) {
        this.sidebar.toggleClass('is-open')
        this.sidebarToggler.toggleClass('is-open')
        this.listGridLayer.toggleClass('is-visible')

        if (scroll) {
            $('html, body').animate({ scrollTop: 0 }, 250)
        }
    }

    /**
     * Handle checkbox click
     */
    handleCheckboxClick(e) {
        let me = $(e.currentTarget)
        let id = me.attr('id')
        let value = me.data('value')
        if (me.is(':checked')) {
            this.createFilterButton(me, id, value)
        } else {
            this.removeFilterButton(id)
        }
        this.updateFilter()
    }

    /**
     * Handle filter button click
     */
    handleFilterButtonClick(e) {
        let me = $(e.currentTarget)
        let id = me.data('checkbox-id')
        this.removeFilterButton(id)
        this.updateFilter()
    }

    /**
     * Update filter
     */
    updateFilter() {
        let selectedFilters = {}
        let $filteredResults = this.productContainer
        this.inputCheckbox.filter(':checked').each(function() {
            if (!selectedFilters.hasOwnProperty(this.name)) {
                selectedFilters[this.name] = []
            }
            selectedFilters[this.name].push($(this).attr('id').replace('l_checkbox_',''))
        })
        $.each(selectedFilters, function(name, filterValues) {
            $filteredResults = $filteredResults.filter(function() {
                let matched = false
                let currentFilterValues = $(this).data('property').split(' ')
                $.each(currentFilterValues, function(_, currentFilterValue) {
                    if ($.inArray(currentFilterValue, filterValues) != -1) {
                        matched = true
                        return false
                    }
                })
                return matched
            })
        })
        this.productContainer.hide().toggleClass('is-filtered', false).filter($filteredResults).show().toggleClass('is-filtered', true)

        if (!$.isEmptyObject(selectedFilters)) {
            this.sortingFilteredItems()
            //this.showInvisibleItems()
            $('.list__content .list__grid').toggleClass('list__grid__filter', false).toggleClass('list__grid__filtered', true)
        } else {
            this.removeSortingFilteredItems()
            //this.hideInvisibleItems()
            this.productContainer.toggleClass('is-filtered', false)
            $('.list__content .list__grid').toggleClass('list__grid__filtered', false).toggleClass('list__grid__filter', true)
        }
    }

    /**
     *  Sorting filtered items for the perfect visual experience <3
     */

    sortingFilteredItems() {
        this.removeSortingFilteredItems()
        $('.is-filtered').each(function(index){
            if (index % 3 === 0) {
                $(this).addClass('first')
            } else if (index % 3 === 1) {
                $(this).addClass('second')
            } else if (index % 3 === 2) {
                $(this).addClass('third')
            }
            if (index % 2 === 0) {
                $(this).addClass('odd')
            } else if (index % 2 === 1) {
                $(this).addClass('even')
            }
        })
    }

    removeSortingFilteredItems() {
        $('.list__grid__item').removeClass('first second third odd even')
    }

    /**
     * Show invisible grid when filtering
     */
    showInvisibleItems() {
        $('.list__grid__item.is-invisible').toggleClass('is-visible', true)
        $('.list__grid__more').toggleClass('is-invisible', true)
    }

    /**
     * Hide invisible grid when filtering
     */
    hideInvisibleItems() {
        $('.list__grid__item.is-invisible.is-visible').toggleClass('is-visible', false).hide()
        $('.list__grid__more.is-invisible').toggleClass('is-invisible', false)
    }

    /**
     * Create filter button
     */
    createFilterButton(me, id, value) {
        let newFilterButton = $('<button/>', {
            "class": 'btn btn--filter filter-button',
            "data-checkbox-id": id,
            html: value
        })
        newFilterButton.appendTo(this.filterButtonContainer)
    }

    /**
     * Remove filter button
     */
    removeFilterButton(id) {
        let target = $('.list__filters input[id='+id+']')
        this.filterButtonContainer.find('button.filter-button[data-checkbox-id='+id+']').remove()
        target.prop('checked', false)
    }

    /**
     * Register event listeners
     */
    registerEvents() {
        // checkbox click
        this.inputCheckbox.on('change', e => this.handleCheckboxClick(e))

        // filter button click
        $('body').on('click', 'button.filter-button', e => this.handleFilterButtonClick(e))
    }

    /**
     * Initialize class
     */
    init() {
        if (this.range) {
            this.startRange()
        }

        if (this.sidebar.length && this.sidebarToggler.length) {
            this.sidebarToggler.on('click', () => this.toggleSidebar(false))
            this.filterApply.on('click', () => this.toggleSidebar(true))
            this.listGridLayer.on('click', () => this.toggleSidebar(true))
        }

        this.registerEvents()
    }
}
